<template>
  <div class="full-height">
    <input v-for="dimensionLevel1FilterRefId in dimensionLevel1FilterRefIds"
           :key="'dimensionLevel1FilterRefId' + dimensionLevel1FilterRefId"
           type="hidden" name="dataForm.data.dimensionLevel1FilterRefIds" :value="dimensionLevel1FilterRefId"/>

    <div v-if="!matrixVisible">
      <i class="fa-light fa-spinner fa-spin" aria-hidden="true"></i>
      {{ pDictionary['dictionary.general.loading'] }}
    </div>
    <table class="table bs3-vertical-center" v-else>
      <thead>
      <tr>
        <th class="width300Pixels" colspan="3" :rowspan="timelineRowSpan">&nbsp;</th>
        <!-- TOTAL -->
        <th class="width150Pixels text-right" :rowspan="timelineRowSpan" v-if="yTotalsVisible">
          <div>Total</div>
        </th>
        <th :rowspan="timelineRowSpan" v-if="yTotalsVisible">&nbsp;</th>
        <!--
         - YEAR
         -->
        <th v-for="timelineYearInfo in timelineYearInfos" :key="timelineYearInfo.name"
            class="width150Pixels text-center" :colspan="timelineYearInfo.colspan">
          <div>{{ timelineYearInfo.name }}</div>
        </th>
        <th :rowspan="timelineRowSpan">&nbsp;</th>
      </tr>
      <!--
       - MONTH
       -->
      <tr v-if="monthTimelineVisible">
        <th v-for="timelineMonthInfo in timelineMonthInfos" :key="timelineMonthInfo.name"
            class="width150Pixels text-center" :colspan="timelineMonthInfo.colspan">
          <div>{{ timelineMonthInfo.name }}</div>
        </th>
      </tr>
      <!--
       - DAY
       -->
      <tr v-if="dayTimelineVisible">
        <th v-for="timelineInfo in timelineInfos" :key="timelineInfo.name"
            class="width150Pixels text-center" colspan="2">
          <div>{{ timelineInfo.dayMonthText }}</div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr :class="[totalBgClass]" v-if="xTotalsVisible">
        <td class="width300Pixels" colspan="3">
          <div>Total</div>
        </td>
        <!-- TOTAL -->
        <td class="width150Pixels text-nowrap text-right" v-if="yTotalsVisible">
          <div>{{ total | money(pCurrencies, pCurrencyId) | emptyToDash }}</div>
        </td>
        <td v-if="yTotalsVisible">
          <!--          <button class="btn btn-default" v-if="hasSibblings"-->
          <!--                  @click.prevent="distribute()">-->
          <!--            <i class="fa-light fa-random"></i></button>-->
        </td>
        <template v-for="timelineInfo in timelineInfos">
          <td class="minWidthCell" :key="'button-' + timelineInfo.key">
            <media-plan-target-measures-matrix-action
                v-if="yActionVisible"
                :p-timeline-info="timelineInfo"
                @media-plan-target-measures-matrix-action="onMeasureAction">
              <i class="fa-light fa-arrow-to-bottom"></i>
            </media-plan-target-measures-matrix-action>
          </td>
          <td class="text-right minWidthCell" :key="'total-' + timelineInfo.key">
            <div class="bs3-padding-right">{{ totalsByCellId[getCellId(null, timelineInfo)] | money(pCurrencies, pCurrencyId) | emptyToDash }}</div>
          </td>
        </template>
        <td>&nbsp;</td>
      </tr>
      <tr v-for="dimensionInfo in dimensionInfos" :key="dimensionInfo.name" :class="[dimensionLevel1BgClass]">
        <td class="minWidthCell">&nbsp;</td>
        <td class="width300Pixels" colspan="2">
          <div>{{ dimensionInfo.name }}</div>
        </td>
        <!-- TOTAL -->
        <td class="text-nowrap text-right" v-if="yTotalsVisible">
          <div>{{ totalsByCellId[getCellId(dimensionInfo, null)] | money(pCurrencies, pCurrencyId) | emptyToDash }}</div>
        </td>
        <td class="minWidthCell" v-if="xActionVisible">
          <media-plan-target-measures-matrix-action
              :p-dimension-info="dimensionInfo"
              @media-plan-target-measures-matrix-action="onMeasureAction">
            <i class="fa-light fa-arrow-to-right"></i>
          </media-plan-target-measures-matrix-action>
        </td>
        <!-- CELL -->
        <td v-for="timelineInfo in timelineInfos" :key="timelineInfo.name" class="width150Pixels" colspan="2">
          <div :id="getCellId(dimensionInfo, timelineInfo)"
               :class="[{'has-error': hasFieldErrors('dataForm.data.measureTextsById[' + getCellId(dimensionInfo, timelineInfo) + ']')}]">
            <input v-model="measuresByCellId[getCellId(dimensionInfo, timelineInfo)]"
                   :name="'dataForm.matrix.dimension1[' + dimensionInfo.id + '].dimension2[0].timeline[' + timelineInfo.key + '].measure'"
                   @change="onCellChange(dimensionInfo, timelineInfo)"
                   type="text" class="form-control text-right" placeholder="0.00$">
            <span
                v-for="(error, errorIndex) in getFieldErrors('dataForm.data.measureTextsById[' + getCellId(dimensionInfo, timelineInfo) + ']')"
                :key="'errorList_dataForm_data_measureTextsById_' + getCellId(dimensionInfo, timelineInfo) + errorIndex" class="help-block">{{
                error
              }}</span>
          </div>
        </td>
        <td>&nbsp;</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import stringHelpers from "@/helpers/string-helpers";
import numberHelpers from "@/helpers/number-helpers";
import MediaPlanTargetMeasuresMatrixAction from "@/components/modules/mediaplan-module/mediaplan-target/form-save-measures/MediaPlanTargetMeasuresMatrixAction";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "MediaPlanTargetUpdateMeasuresMatrix",
  components: {MediaPlanTargetMeasuresMatrixAction},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pCurrencyId: Number,
    pMediaPlanTargetId: Number,
    pMeasureToken: String,
    pDimensionLevel1Token: String,
    pDimensionLevel1FilterRefs: Array,
    pTimeline: String,
    pMeasuresByCellId: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      timelineInfos: [],
      dimensionInfos: [],
      measuresByCellId: this.pMeasuresByCellId
    };
  },
  methods: {
    /*
     *
     */
    getCellId: function (dimensionInfo, timelineInfo) {
      return (dimensionInfo !== null ? dimensionInfo.id : '0') // Dimension1
             + '-0' // Dimension2
             + "-" + (timelineInfo !== null ? timelineInfo.key : '0'); // Timeline
    },
    /*
     *
     */
    onCellChange: function (dimensionInfoLevel1, timelineInfo) {

    },
    /*
     *
     */
    onMeasureAction: function (action, measureText, dimensionInfo, timelineInfo) {
      if('COPY' === action)
      {
        if(dimensionInfo != null)
        {
          this.copySibblings(dimensionInfo, measureText)
        }
        else if(timelineInfo != null)
        {
          this.copyChilds(timelineInfo, measureText);
        }
      }
      else if('DISTRIBUTE' === action)
      {
        if(dimensionInfo != null)
        {
          this.distributeSibblings(dimensionInfo, measureText)
        }
        else if(timelineInfo != null)
        {
          this.distributeChilds(timelineInfo, measureText);
        }
      }
    },
    /*
     *
     */
    copyChilds: function (timelineInfo, measureText) {
      let measure = numberHelpers.parse(measureText, 0, 2,
                                        this.pThousandDelimiter, this.pDecimalDelimiter);
      for(let i = 0; i < this.dimensionInfos.length; i++)
      {
        let dimensionInfo = this.dimensionInfos[i];
        // Set cell number.
        this.setMeasure(dimensionInfo, timelineInfo, measure);
      }
    },
    /*
     *
     */
    copySibblings: function (dimensionInfo, measureText) {
      let measure = numberHelpers.parse(measureText, 0, 2,
                                        this.pThousandDelimiter, this.pDecimalDelimiter);
      for(let i = 0; i < this.timelineInfos.length; i++)
      {
        this.setMeasure(dimensionInfo, this.timelineInfos[i], measure);
      }
    },
    /*
     *
     */
    distributeChilds: function (timelineInfo, measureText) {
      let measure = numberHelpers.parse(measureText, 0, 2,
                                        this.pThousandDelimiter, this.pDecimalDelimiter);
      let cellNumberParts = numberHelpers.divideEqually(measure, this.dimensionInfos.length, 2);
      for(let i = 0; i < this.dimensionInfos.length; i++)
      {
        this.setMeasure(this.dimensionInfos[i], timelineInfo, cellNumberParts[i]);
      }
    },
    /*
     *
     */
    distributeSibblings: function (dimensionInfo, measureText) {
      let measure = numberHelpers.parse(measureText, 0, 2,
                                        this.pThousandDelimiter, this.pDecimalDelimiter);
      let cellNumberParts = numberHelpers.divideEqually(measure, this.timelineInfos.length, 2);
      for(let i = 0; i < this.timelineInfos.length; i++)
      {
        this.setMeasure(dimensionInfo, this.timelineInfos[i], cellNumberParts[i]);
      }
    },
    /*
     *
     */
    setMeasure: function (dimensionInfo, timelineInfo, measure) {
      let cellId = this.getCellId(dimensionInfo, timelineInfo);
      let measureText = numberHelpers.format(measure, 2, this.pThousandDelimiter, this.pDecimalDelimiter);

      // console.log("setMeasure() -> [CellId=" + cellId + "] [MeasureNumber=" + measureText +"]")

      this.$set(this.measuresByCellId, cellId, measureText);
    },
    /*
     *
     */
    getTimelineInfos: function (timeline) {
      let _component = this;
      $.ajax({
               type: "GET",
               url: '/mediaplan/app/endpoints/json-api/media-plans/targets/timeline-info?mediaPlanTargetId='
                    + _component.pMediaPlanTargetId + "&" + 'calendarTimeline=' + timeline,
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (timelineInfos) {
        _component.timelineInfos = timelineInfos;
      });
    },
    adjustMeasuresToTimeline: function (fromTimeline, toTimeline) {
      let _component = this;

      // console.log('adjustMeasuresToTimeline [FromTimeline=' + fromTimeline + "] [ToTimeline=" + toTimeline + "]");

      const data = {
        'mediaPlanTargetId': _component.pMediaPlanTargetId,
        'fromTimeline': fromTimeline,
        'toTimeline': toTimeline,
        'measures': _component.measuresByCellId
      }

      $.ajax({
               type: "POST",
               url: '/mediaplan/app/endpoints/json-api/media-plans/targets/measures/adjust/timeline',
               data: JSON.stringify(data),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (measuresByCellId) {
        _component.measuresByCellId = measuresByCellId;
      });
    },
    /*
     *
     */
    getDimensionInfos: function (dimensionLevel1Token) {
      let _component = this;
      let url = '/mediaplan/app/endpoints/json-api/media-plans/targets/dimension-info?mediaPlanTargetId=' +
                +_component.pMediaPlanTargetId + "&" + 'dimensionLevel1Token=' + dimensionLevel1Token;
      for(let i = 0; i < this.dimensionLevel1FilterRefIds.length; i++)
      {
        url += '&dimensionLevel1FilterRefIds=' + this.dimensionLevel1FilterRefIds[i];
      }

      $.ajax({
               type: "GET",
               url: url,
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (dimensionInfos) {
        _component.dimensionInfos = dimensionInfos;
      });
    }
  },
  computed: {
    dimensionLevel1FilterRefIds: function() {
      return refHelpers.getRefIds(this.pDimensionLevel1FilterRefs, [])
    },
    matrixVisible: function () {
      return this.timelineInfos.length > 0
             && this.dimensionInfos.length > 0;
    },
    yTotalsVisible: function () {
      return this.timelineInfos.length > 1;
    },
    xTotalsVisible: function () {
      return this.dimensionInfos.length > 0;
    },
    yActionVisible: function() {
      return this.dimensionInfos.length > 1;
    },
    xActionVisible: function() {
      return this.timelineInfos.length > 1;
    },
    hasSibblings: function () {
      return this.timelineInfos.length > 0;
    },
    hasChilds: function () {
      return this.dimensionInfos.length > 0;
    },
    hasDimensionLevel1: function () {
      return !stringHelpers.isEmptyOrNull(this.pDimensionLevel1Token);
    },
    timelineYearInfos: function () {
      let timelineYearInfos = [];

      // Display the year in the timeline.
      let colspan = 0;
      let currentName = null;
      for(let i = 0; i < this.timelineInfos.length; i++)
      {
        let timelineInfo = this.timelineInfos[i];

        if(currentName === null)
        {
          colspan = 1;
          currentName = timelineInfo.year;
        }
        else if(currentName !== timelineInfo.year)
        {
          timelineYearInfos.push({'name': currentName, 'colspan': colspan * 2});
          colspan = 1;
          currentName = timelineInfo.year;
        }
        else
        {
          colspan++;
        }
      }

      if(currentName === null)
      {
        currentName = 'Total'
        colspan = 1;
      }

      timelineYearInfos.push({'name': currentName, 'colspan': colspan * 2});

      return timelineYearInfos;
    },
    timelineMonthInfos: function () {
      let timelineMonthInfos = [];
      if(this.dayTimelineVisible || this.monthTimelineVisible)
      {
        let colspan = 0;
        let currentName = null;
        for(let i = 0; i < this.timelineInfos.length; i++)
        {
          let timelineInfo = this.timelineInfos[i];

          if(currentName === null)
          {
            colspan = 1;
            currentName = timelineInfo.month;
          }
          else if(currentName !== timelineInfo.month)
          {
            timelineMonthInfos.push({'name': currentName, 'colspan': colspan * 2});
            colspan = 1;
            currentName = timelineInfo.month;
          }
          else
          {
            colspan++;
          }
        }

        timelineMonthInfos.push({'name': currentName, 'colspan': colspan * 2});
      }
      return timelineMonthInfos;
    },
    monthTimelineVisible: function () {
      return this.pTimeline === 'DAY'
             || this.pTimeline === 'WEEK'
             || this.pTimeline === 'MONTH'
             || this.pTimeline === 'QUARTER';
    },
    dayTimelineVisible: function () {
      return this.pTimeline === 'DAY'
             || this.pTimeline === 'WEEK';
    },
    timelineRowSpan: function () {
      if(this.dayTimelineVisible)
      {
        return 3
      }
      if(this.monthTimelineVisible)
      {
        return 2;
      }
      return 1;
    },
    totalsByCellId: function () {
      let totalsByCellId = {};

      for(let i = 0; i < this.timelineInfos.length; i++)
      {
        let timelineInfo = this.timelineInfos[i];
        // Sum childs (Column)) -> Total-Total-<Timeline>
        let columnSum = this.dimensionInfos.reduce(
            (partialSum, di) => partialSum + numberHelpers.parse(
                this.measuresByCellId[this.getCellId(di, timelineInfo)], 0, 2,
                this.pThousandDelimiter, this.pDecimalDelimiter), 0);
        totalsByCellId[this.getCellId(null, timelineInfo)] =
            numberHelpers.format(columnSum, 2, this.pThousandDelimiter, this.pDecimalDelimiter);
      }

      for(let i = 0; i < this.dimensionInfos.length; i++)
      {
        let dimensionInfo = this.dimensionInfos[i];
        // Sum sibblings (Row) -> <Dimension>-Total-Total
        const rowSum = this.timelineInfos.reduce(
            (partialSum, ti) => partialSum + numberHelpers.parse(
                this.measuresByCellId[this.getCellId(dimensionInfo, ti)], 0, 2,
                this.pThousandDelimiter, this.pDecimalDelimiter), 0);
        totalsByCellId[this.getCellId(dimensionInfo, null)] =
            numberHelpers.format(rowSum, 2, this.pThousandDelimiter, this.pDecimalDelimiter);
      }

      return totalsByCellId;
    },
    total: function () {
      let total = 0;
      for(let i = 0; i < this.timelineInfos.length; i++)
      {
        let timelineInfo = this.timelineInfos[i];

        for(let i = 0; i < this.dimensionInfos.length; i++)
        {
          let dimensionInfo = this.dimensionInfos[i];

          total += numberHelpers.parse(
              this.measuresByCellId[this.getCellId(dimensionInfo, timelineInfo)], 0, 2,
              this.pThousandDelimiter, this.pDecimalDelimiter);
        }
      }
      return numberHelpers.format(total, 2, this.pThousandDelimiter, this.pDecimalDelimiter);
    },
    totalBgClass: function () {
      if(this.hasDimensionLevel1)
      {
        return "blockingChartGroupLevel1"
      }
      return "";
    },
    dimensionLevel1BgClass: function () {
      return "";
    }
  },
  watch: {
    pDimensionLevel1Token: function (newDimensionLevel1Token) {
      // console.log("pDimensionLevel1Token changed:" + newDimensionLevel1Token);
      this.getDimensionInfos(newDimensionLevel1Token);
    },
    pTimeline: function (newTimeline, oldTimeline) {
      // console.log("pTimeline changed:" + newTimeline);
      this.getTimelineInfos(newTimeline);
      this.adjustMeasuresToTimeline(oldTimeline, newTimeline);
    }
  },
  mounted: function () {
    let _component = this;
    // console.log("Matrix-Mounted: [Dimension=" + this.pDimensionLevel1Token + "] [Timeline=" + this.pTimeline + "]");
    _component.getDimensionInfos(this.pDimensionLevel1Token);
    _component.getTimelineInfos(this.pTimeline);
  }
}
</script>

<style scoped>

</style>